module.exports = __webpack_public_path__ + "static/img/1-2.3c56672.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/1-2.png
// module id = GkVQ
// module chunks = 0